import formBaseMixin from '@/components/form/form-base-mixin'
import url from '@/utils/url'

export default {
  mixins: [formBaseMixin],
  data() {
    return {
      fields: {
        name: '',
      },
    }
  },
  computed: {
    formTitle() {
      if (this.item && this.fields.id) {
        if (this.item.name) {
          return this.item.name
        }
        return this.$translate('Редактирование записи')
      }
      return this.$translate('Добавление группы тарифов')
    },
  },
  methods: {
    /**
     * @override
     */
    getRedirectParams() {
      if (this.itemId) {
        return formBaseMixin.methods.getRedirectParams.call(this)
      }
      let route = url.getRoute(this.$route)
      return {
        name: 'billing.branchs.update',
        params: { id: this.fields.id },
        query: route.query,
      }
    },
  },
  asyncData({ store, route, fromRoute, methods }) {
    const promises = []
    const endpoints = [methods.getItemEndpoint]

    endpoints.forEach((endpointFunc) => {
      let endpoint = endpointFunc(route, fromRoute)
      if (endpoint) {
        promises.push(store.dispatch('updateUrlEndpoint', { endpoint }))
      }
    })

    return promises.length ? Promise.all(promises) : Promise.resolve(true)
  },
}
